<template>
  <div>
    <s-loader :active="!projectTemplates && loading" />
    <div v-if="projectTemplates !== null">
      <div
        v-for="projectTemplate in projectTemplates"
        :key="projectTemplate.id"
        class="template-snippet card card--overflow-visible mt-12px"
      >
        <router-link :to="{ name: $consts.urls.URL_PROJECT_COMPLIANCE, params: { projectId: projectTemplate.id } }">
          <ui-box class="template-snippet__inside py-16px">
            <div class="template-snippet__title">
              <span class="has-text-weight-medium has-text-primary">{{ projectTemplate.name }}</span>

              <prismic-content :doctype="DOCUMENT_TYPE_PROJECTS_LIST" v-slot="{ content }">
                <div @click.prevent v-if="$prismicHasText(content.project_template_tooltip)">
                  <ui-tooltip
                    :content="$prismicText(content.project_template_tooltip)"
                    position="is-right"
                    :iconSpacing="8"
                    @click.prevent
                  />
                </div>
              </prismic-content>
            </div>
            <span class="has-text-weight-medium has-text-primary">{{ progressFormatted(projectTemplate) }}</span>
          </ui-box>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import PrismicContent from '@/components/prismic/prismic-content'
import UiBox from '@/components/ui/box'
import UiTooltip from '@/components/ui/tooltip'
import { DOCUMENT_TYPE_PROJECTS_LIST } from '@/consts/prismic'

export default {
  components: {
    PrismicContent,
    UiBox,
    UiTooltip
  },
  props: {
    loading: { type: Boolean },
    projectTemplates: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      DOCUMENT_TYPE_PROJECTS_LIST
    }
  },
  computed: {},
  methods: {
    progressFormatted(projectTemplate) {
      const stats = projectTemplate.stats
      if (stats.directIndicatorsApplicableCount === 0) return 0

      return Math.round((stats.directIndicatorsCompletedCount / stats.directIndicatorsApplicableCount) * 100) + '%'
    }
  }
}
</script>
<fragments>
fragment projectTemplatesList on ProjectGraphType {
  id
  stats {
    directIndicatorsCompletedCount
    directIndicatorsApplicableCount
  }
}
</fragments>
<style lang="scss" scoped>
.template-snippet {
  background-color: $white;
  background: linear-gradient(90deg, #e6ecf4 22.71%, $white 100%);
  border: 1px solid $blue;
  transition: border 0.2s ease-in-out;

  &:hover,
  &:active {
    border-color: $primary;
  }

  &__inside {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    display: flex;
    align-items: center;
  }
}
</style>

